import { useTranslation } from 'react-i18next';
import React from 'react';
import { COLOR } from '@src/styles/color';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CommonButton from '@src/new-components/Button';

const PreviousEventButton = ({ onPreviousEvent }) => {
  const { t } = useTranslation();

  return (
    <CommonButton
      variant="outlineSmall"
      onClick={onPreviousEvent}
      customStyle={{
        borderRadius: '12px',
        height: '48px',
        padding: '12px',
      }}
      textProps={{
        variantText: 'body-16-semibold',
        color: COLOR.darkBlue,
        className: 'text-previous-event-button',
      }}
      endIcon={
        <ArrowForwardRoundedIcon
          sx={{ fontSize: '24px', color: COLOR.navyBlue }}
        />
      }
    >
      {t('previousEvent')}
    </CommonButton>
  );
};

export default PreviousEventButton;
